import React from 'react';
import { Icon } from '@iconify/react';

const IconComponent = ({ click }) => (
  <div>
    <Icon icon={click ? 'ph:x-bold' : 'fa6-solid:bars-staggered'} />
  </div>
);

export default IconComponent;